import Joi from 'joi-browser';
import { messageUtility } from '../messageUtility';

export const agencyRegistrationApplicationSchema = {
  company_agent_to: Joi.any().required(), //代行先会社ID
  company_agent_to_users: Joi.array()
    .required()
    .min(1)
    .error(() => ({
      type: 'validation.custom',
      message: messageUtility.getMessage('E-000-010'),
    })),
  original_filename: Joi.any().required(), // 覚書テンプレートファイル
};

export const agencyRegistrationSaveSchema = {
  company_agent_to: Joi.any().required(), //代行先会社ID
  company_agent_to_users: Joi.array().error(() => ({
    type: 'validation.custom',
    message: messageUtility.getMessage('E-000-010'),
  })),
  original_filename: Joi.any(), // 覚書テンプレートファイル
};



// WEBPACK FOOTER //
// ./src/utilities/validationSchemas/agencyRegistrationApplication.js